import { Navigate, useNavigate } from "react-router-dom";
import config from "../config";
const base_url = config.base_url;
export const checkLoginStatus = () => {
  return new Promise((resolve, reject) => {
    const current_location = window.location.pathname;
    if (!current_location.startsWith("/user")) {
      return;
    } else {
      const date = window.sessionStorage.getItem("ostreon_login");
      if (!date) return;

      if (Number(date) + 20 * 1000 > Date.now()) return;
      fetch(base_url + "login", {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-type": "application/x-www-form-urlencoded",
          credentials: "include",
        },
        credentials: "include",
      })
        .then(async (res) => {
          resolve(res);
        })
        .catch((e) => {
          console.log(e);
          reject();
        })
        .finally((_) => {
          window.sessionStorage.setItem("ostreon_login", Date.now());
        });
    }
  });
};
